export default "__VITE_ASSET__DCUd9gX7__"